import React from 'react';
import { Badge } from '../ui/badge';

const trimLabel = (value, max = 22) => {
  if (!value) return '';
  const str = String(value);
  return str.length > max ? `${str.slice(0, max - 1)}…` : str;
};

const buildScopeItems = (filters = {}) => {
  const items = [];
  if (filters?.year) items.push({ label: filters.year, tone: 'emerald' });
  if (filters?.quarter) items.push({ label: filters.quarter, tone: 'amber' });
  if (filters?.salesRep) items.push({ label: `Rep: ${trimLabel(filters.salesRep)}`, tone: 'blue' });
  if (filters?.productDirector) items.push({ label: `PD: ${trimLabel(filters.productDirector)}`, tone: 'violet' });
  if (filters?.solutionCategory) items.push({ label: `Category: ${trimLabel(filters.solutionCategory)}`, tone: 'slate' });
  if (filters?.stage) items.push({ label: `Stage: ${trimLabel(filters.stage)}`, tone: 'rose' });
  return items;
};

const toneClasses = {
  emerald: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  amber: 'border-amber-200 bg-amber-50 text-amber-700',
  blue: 'border-blue-200 bg-blue-50 text-blue-700',
  violet: 'border-violet-200 bg-violet-50 text-violet-700',
  slate: 'border-slate-200 bg-slate-50 text-slate-700',
  rose: 'border-rose-200 bg-rose-50 text-rose-700',
};

export function HealthFilterScopeRibbon({ filters = {}, className = '' }) {
  const items = buildScopeItems(filters);

  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`} data-testid="health-card-filter-scope-ribbon">
      {items.length === 0 ? (
        <Badge variant="outline" className="border-slate-200 bg-slate-50 text-slate-500 text-[10px] h-5">
          All data
        </Badge>
      ) : items.map((item) => (
        <Badge key={item.label} variant="outline" className={`${toneClasses[item.tone] || toneClasses.slate} text-[10px] h-5`}>
          {item.label}
        </Badge>
      ))}
    </div>
  );
}
